import { Feature } from '@tencent/workbench';
import { config } from './config';
import { BaseGuideFeature } from '../../common/feature/base-guide-feature';
import { IGridLineFeature } from './grid-line-interface';

@Feature()
export class GridLineFeature extends BaseGuideFeature implements IGridLineFeature {
    public id = config.id;
    public config = config;

    protected isDisplayed(): boolean {
        return !!this.getAppService().editableServiceLayer?.gridLineManager?.displayGridLine;
    }

    protected updateDisplay(): void {
        this.getAppService().editableServiceLayer?.gridLineManager?.changeDisplayGridLine();
    }
}
